import { z } from "zod";
import { toAsciiDigits } from "./common.js";

/**
 * Iranian mobile number, normalised to E.164 (+989XXXXXXXXX).
 * Accepts 09…, 9…, 989…, +989…, 00989…, Persian digits, spaces and dashes.
 * One phone number = one person (ADR-29).
 */
export const MobilePhone = z
  .string()
  .transform((raw, ctx) => {
    const digits = toAsciiDigits(raw).replace(/[\s\-()]/g, "");
    const m = /^(?:\+98|0098|98|0)?(9\d{9})$/.exec(digits);
    if (!m) {
      ctx.addIssue({ code: "custom", message: "شماره‌ی موبایل معتبر نیست" });
      return z.NEVER;
    }
    return `+98${m[1] ?? ""}`;
  })
  .brand<"MobilePhone">();
export type MobilePhone = z.infer<typeof MobilePhone>;
